import { useBreakpointValue } from "@gluestack-ui/themed";
import useToast from "@repo/core/components/core/Toast";
import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import {
  IModalOption,
  IModalTemplateType
} from "@repo/core/components/layout/ModalTemplate/types";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useRouteParams } from "@repo/core/hooks/useRouteParams";
import { ROUTES } from "@repo/core/routes";
import {
  InvoiceAndDealPaymentResponseDTO,
  InvoiceAndDealPaymentType
} from "@repo/core/services/entities/Terminal";
import { apiInstance } from "@repo/core/services/instances/api";
import { CardResource } from "@repo/core/services/resources/card";
import { TerminalResource } from "@repo/core/services/resources/terminal";
import { useRef, useState } from "react";

const cardResource = new CardResource(apiInstance);
const terminalResource = new TerminalResource(apiInstance);

export const ConfirmPaymentController = () => {
  const { error } = useToast();
  const { back, replace } = useNavigation();
  const [isValidatingPassword, setIsValidatingPassword] = useState(false);
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [receiptData, setReceiptData] = useState<
    InvoiceAndDealPaymentResponseDTO["strComprovante"] | null
  >(null);

  const alertModalRef = useRef<IModalRefProps>(null);

  const state = useRouteParams();

  const paymentInfo: InvoiceAndDealPaymentType = state;

  const handleConfirmCardPassword = async (password: string) => {
    if (!password) return;
    try {
      setIsValidatingPassword(true);

      const { data } = await cardResource.validateCardPassword(
        paymentInfo.strPlastico,
        password
      );

      if (data) {
        const { data: receiptInfo } =
          await terminalResource.invoicePaymentTerminal(paymentInfo);
        setReceiptData(receiptInfo.strComprovante);
        alertModalRef.current?.open();
      }
    } catch (err: unknown) {
      error("Senha incorreta, por favor verifique a senha e tente novamente.");
    } finally {
      setIsValidatingPassword(false);
    }
  };
  const handleSeeReceipt = async () => {
    if (receiptData) {
      replace(ROUTES.invoicePaymentReceipt, receiptData);
    }
  };

  const handleGoToStart = () => {
    replace(ROUTES.home);
  };

  const alertOptions: IModalOption[] = [
    {
      label: "Voltar ao início",
      onPress: handleGoToStart,
      type: IModalTemplateType.success
    },
    {
      label: "Ver comprovante",
      type: IModalTemplateType.outline,
      onPress: handleSeeReceipt
    }
  ];
  return {
    back,
    isMobile,
    isValidatingPassword,
    handleConfirmCardPassword,
    alertModalRef,
    alertOptions,
    receiptData
  };
};
